import { AdvertentieTile, ADVERTENTIE_TILE_KEY } from "./AdvertentieTile";
import { AnimalsTile, ANIMALS_TILE_KEY } from "./AnimalsTile";
import { BreedWeightTile, BREED_WEIGHT_TILE_KEY } from "./BreedWeightTile";
import { CommunicationTile, COMMUNICATION_TILE_KEY } from "./CommunicationTile";
import { FinanceTile, FINANCE_TILE_KEY } from "./FinanceTile";
import { GemeenteTile, GEMEENTE_TILE_KEY } from "./GemeenteTile";
import { IntegrationsTile, INTEGRATIONS_TILE_KEY } from "./IntegrationsTile";
import { PensionTile, PENSION_TILE_KEY } from "./PensionTile";
import { PleeggezinnenTile, PLEEGGEZINNEN_TILE_KEY } from "./PleeggezinnenTile";
import { PlatformConnectionTile, PLATFORM_CONNECTION_TILE_KEY } from "./PlatformConnectionTile";
import { TakenTile, TAKEN_TILE_KEY } from "./TakenTile";
import { VoedingTile, VOEDING_TILE_KEY } from "./VoedingTile";
import { WizardTile, WIZARD_TILE_KEY } from "./WizardTile";
import type { ContextType, SettingsTileComponent } from "./types";

// jve-settings: the tile registry + per-context section layout — the React equivalent of the Jmix
// `tilesForContext()` / `sectionsForContext()`. Each configuration group is its own component
// (key → component here); the dashboard composes them per context. Adding a tile = add its file +
// one entry here.

const TILE_COMPONENTS: Record<string, SettingsTileComponent> = {
  [ADVERTENTIE_TILE_KEY]: AdvertentieTile,
  [ANIMALS_TILE_KEY]: AnimalsTile,
  [BREED_WEIGHT_TILE_KEY]: BreedWeightTile,
  [GEMEENTE_TILE_KEY]: GemeenteTile,
  [FINANCE_TILE_KEY]: FinanceTile,
  [COMMUNICATION_TILE_KEY]: CommunicationTile,
  [INTEGRATIONS_TILE_KEY]: IntegrationsTile,
  [PENSION_TILE_KEY]: PensionTile,
  [PLEEGGEZINNEN_TILE_KEY]: PleeggezinnenTile,
  [PLATFORM_CONNECTION_TILE_KEY]: PlatformConnectionTile,
  [TAKEN_TILE_KEY]: TakenTile,
  [WIZARD_TILE_KEY]: WizardTile,
  [VOEDING_TILE_KEY]: VoedingTile,
};

export interface SectionLayout {
  titleKey: string;
  tileKeys: string[];
}

// Section grouping per context — mirrors SettingsDashboardView.sectionsForContext().
export function sectionsForContext(type: ContextType): SectionLayout[] {
  if (type === "branch") {
    return [
      {
        titleKey: "instellingen.section.algemeen",
        tileKeys: [
          TAKEN_TILE_KEY,
          WIZARD_TILE_KEY,
          PENSION_TILE_KEY,
          PLEEGGEZINNEN_TILE_KEY,
          COMMUNICATION_TILE_KEY,
        ],
      },
      { titleKey: "instellingen.section.dieren", tileKeys: [VOEDING_TILE_KEY, BREED_WEIGHT_TILE_KEY] },
      { titleKey: "instellingen.section.financieel", tileKeys: [FINANCE_TILE_KEY, INTEGRATIONS_TILE_KEY] },
    ];
  }
  return [
    { titleKey: "instellingen.section.algemeen", tileKeys: [GEMEENTE_TILE_KEY, FINANCE_TILE_KEY] },
    {
      titleKey: "instellingen.section.dieren",
      tileKeys: [
        ANIMALS_TILE_KEY,
        VOEDING_TILE_KEY,
        TAKEN_TILE_KEY,
        WIZARD_TILE_KEY,
        BREED_WEIGHT_TILE_KEY,
        // Eén advertentie-instelling voor alle asielen (maintainer 2026-08-23), dus hier en niet
        // meer bij de vestiging.
        ADVERTENTIE_TILE_KEY,
        COMMUNICATION_TILE_KEY,
        INTEGRATIONS_TILE_KEY,
        // Pairing epic D: one platform connection per backoffice; hidden without the admin authority.
        PLATFORM_CONNECTION_TILE_KEY,
      ],
    },
  ];
}

export function tileComponent(key: string): SettingsTileComponent | undefined {
  return TILE_COMPONENTS[key];
}
